var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "transition-all duration-300",
      class: [_vm.showing ? "h-15" : "h-0"],
      style: { width: "calc(100vw - 0.5rem)" }
    },
    [
      _vm.clientTargetJob
        ? _c(
            "div",
            {
              staticClass:
                "h-15 px-6 rounded-b flex items-center justify-between gap-2",
              class: [
                _vm.wasCompletedButHasFailed
                  ? "bg-pending-100"
                  : "bg-success-100"
              ]
            },
            [
              _c("div", { staticClass: "flex items-center gap-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "h-10 w-10 flex-shrink-0 grid place-items-center",
                    style: {
                      background: _vm.wasCompletedButHasFailed
                        ? "#F7E5AA"
                        : "#D1FAA1",
                      borderRadius: "0.25rem"
                    }
                  },
                  [
                    _vm.wasCompletedButHasFailed
                      ? _c("BlIcon", {
                          staticClass: "h-6 w-6",
                          attrs: { icon: "warning", color: "pending-4" }
                        })
                      : _vm.clientTargetJob.status === "completed"
                      ? _c("BlIcon", {
                          staticClass: "h-6 w-6",
                          attrs: { icon: "check-circle", color: "success" }
                        })
                      : _c("BlIcon", {
                          staticClass: "w-6 animate-spin",
                          attrs: { icon: "update", color: "success" }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _vm.wasCompletedButHasFailed
                      ? _c("BlTextBody2", {
                          staticClass: "text-pending",
                          attrs: {
                            text:
                              "Some targets were not successfully added. Please review and retry for the unsuccessful targets."
                          }
                        })
                      : _vm.clientTargetJob.status === "completed"
                      ? _c("BlTextBody2", {
                          staticClass: "text-success",
                          attrs: {
                            text:
                              "The process of adding targets to the client from the databank is complete. You can now resume adding new targets."
                          }
                        })
                      : _c("BlTextBody2", {
                          staticClass: "text-success",
                          attrs: {
                            text:
                              "Targets are currently being added to the client from the databank. Please wait until the process is complete to add new targets."
                          }
                        }),
                    _vm._v(" "),
                    _vm.clientTargetJob.status === "completed" ||
                    _vm.clientTargetJob.status === "canceled"
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlTextSubtitle3", {
                              class: [
                                _vm.wasCompletedButHasFailed
                                  ? "text-pending"
                                  : "text-success"
                              ],
                              attrs: {
                                text:
                                  "Successful targets added: " +
                                  _vm.clientTargetJob.total_success
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "h-1 w-1 rounded-full",
                              class: [
                                _vm.wasCompletedButHasFailed
                                  ? "bg-pending-300"
                                  : "bg-success-300"
                              ]
                            }),
                            _vm._v(" "),
                            _c("BlTextSubtitle3", {
                              class: [
                                _vm.wasCompletedButHasFailed
                                  ? "text-pending"
                                  : "text-success"
                              ],
                              attrs: {
                                text:
                                  "Failed targets: " +
                                  _vm.clientTargetJob.total_errors
                              }
                            })
                          ],
                          1
                        )
                      : _c("BlTextSubtitle3", {
                          staticClass: "text-success",
                          attrs: {
                            text:
                              "Remaining targets: " +
                              _vm.clientTargetJob.remaining_targets
                          }
                        })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.clientTargetJob.status === "in_progress" ||
              _vm.clientTargetJob.status === "pending"
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "outline-none border border-lime-500 rounded flex items-center justify-center h-8 px-4",
                        class: _vm.cancelLoading
                          ? "bg-grey-100 cursor-wait"
                          : "bg-pure-white hover:bg-grey-200 cursor-pointer",
                        attrs: { disabled: _vm.cancelLoading },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onCancelJob($event)
                          }
                        }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "font-semibold text-sm text-lime-700 tracking-wide",
                            class: _vm.cancelLoading
                              ? "cursor-wait"
                              : "cursor-pointer"
                          },
                          [_vm._v("\n          Cancel import\n        ")]
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0682a426", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0682a426","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/TargetJobProgression.vue
// module id = null
// module chunks = 